import React from 'react';
import { colors } from '@/globalStyles';

const getFillColor = ({ primitiveProps, logicalType }) => {
  const { background_style } = primitiveProps;

  if (logicalType === 'hole') {
    return colors.white;
  } else if (background_style?.enabled) {
    return background_style.fill_color;
  }
  return colors.transparent;
};

const PolygonComponent = props => {
  const { style, className, id, primitiveProps, logicalType, svgElementClickableRef } = props;
  const { points, outline_style } = primitiveProps;
  const parsedStyle = style ? JSON.parse(JSON.stringify(style)) : {};
  const styles = {
    ...parsedStyle,
    pointerEvents: className === 'decoration' ? 'none' : 'unset',
    ...(!parsedStyle.fill && { fill: getFillColor({ primitiveProps, logicalType }) }),
    ...(!parsedStyle.stroke && { stroke: outline_style && outline_style.enabled && outline_style.color ? outline_style.color : colors.black }),
  };

  return <polygon id={id} points={points} style={styles} ref={svgElementClickableRef} className={className} />;
};

export default PolygonComponent;
